import Skeleton from "components/Skeleton";

import cn from "lib/cn";

interface LoaderSkeletonProps {
  number?: number;
  className?: string;
  withContainer?: boolean;
  containerClassName?: string;
}

const LoaderSkeleton = ({
  number = 1,
  className,
  withContainer = true,
  containerClassName,
}: LoaderSkeletonProps) => {
  const skeletons = [...Array(number)].map((_, idx) => (
    <Skeleton key={idx} className={cn("w-full mx-auto", className)} />
  ));

  return withContainer ? (
    <div className={cn("flex gap-2", containerClassName)}>{skeletons}</div>
  ) : (
    <>{skeletons}</>
  );
};

export default LoaderSkeleton;
